import { InjectableClass } from '@fino/lib-injection';
import _ from 'lodash';

export class FormButtonController extends InjectableClass {
  constructor(controllerService) {
    'ngInject';
    super({ controllerService });
  }

  $onInit() {
    // Button type defaults to button
    if (!this.btnType) {
      this.btnType = 'button';
    }

    // Handle given type class
    switch (this.btnTypeClass) {
      case 'primary': {
        this.btnPrimary = true;
        this.btnDefault = false;
        break;
      }
      case 'success': {
        this.btnSuccess = true;
        this.btnDefault = false;
        break;
      }
      case 'info': {
        this.btnInfo = true;
        this.btnDefault = false;
        break;
      }
      case 'warning': {
        this.btnWarning = true;
        this.btnDefault = false;
        break;
      }
      case 'danger': {
        this.btnDanger = true;
        this.btnDefault = false;
        break;
      }
      case 'link': {
        this.btnLink = true;
        this.btnDefault = false;
        break;
      }
      default: {
        this.btnDefault = !(this.btnPrimary || this.btnSuccess || this.btnInfo || this.btnWarning || this.btnDanger);
        break;
      }
    }

    // Set button classes
    this.btnClasses = _.pickBy({
      'btn-default': this.btnDefault,
      'btn-primary': this.btnPrimary,
      'btn-success': this.btnSuccess,
      'btn-info': this.btnInfo,
      'btn-warning': this.btnWarning,
      'btn-danger': this.btnDanger,
      'btn-link': this.btnLink,
      'btn-block': this.btnBlock,
      'btn-lg': this.btnLarge,
      'btn-sm': this.btnSmall,
      'btn-xs': this.btnXSmall
    });

    if (this.btnClass) {
      this.btnClasses[this.btnClass] = true;
    }
  }
}
